export const css = {
    root: '_3VtFEpWb',
    recordsContainer: '_3dbAYyQD',
    panel: 'f3s3V1Kp',
    panelDefault: 'sb0WtxTO',
    panelHeading: '_30AIIglT',
    panelWarning: '_2FmmpZKa',
    panelBody: 'hYEQQXK3',
    announcementBody: 'RmLVYZyA',
    announcementTitle: '_3NIrPoJv',
    announcementPubdate: '_2s8JzX0B',
    ' _key': 'announcements/announcements'
};
export default css;
